import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 4.05a.7.7 0 0 0-.373.107l-8.3 5.22a.7.7 0 0 0 0 1.185l8.3 5.22a.7.7 0 0 0 .373.108v-1.527L5.015 9.97 12 5.577zm1.4 9.433 5.585-3.513L13.4 6.457V4.804l7.273 4.573a.7.7 0 0 1 0 1.185L13.4 15.137zm-1.4 4.94-7.927-4.986a.7.7 0 0 0-.746 1.186l8.3 5.22a.7.7 0 0 0 .373.107zm1.4.773v-1.653l6.527-4.106a.7.7 0 0 1 .746 1.186z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.6 3.7a.7.7 0 1 1 1.4 0v16.6a.7.7 0 1 1-1.4 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11 5.5 4 10l7 4.5z"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=VersionCompareIcon24.js.map